import IntelLayout from "@components/layout/layout";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import { getUserActivePlan } from "@helpers/profileHelper";
import { LOB_ENUM } from "@routes/intel/ProductOnboarding/utils";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import ModifyInputs from "./components/ModifyInputs";
import { IMP_EXP_PERSONAS } from "./constants";
import RecommendationsView from "./RecommendationsView";

const SUPPORTED_PERSONAS: string[] = [LOB_ENUM.BUSINESS_DEVELOPMENT, ...IMP_EXP_PERSONAS];

const IntelHub = () => {
  const { pathname } = useLocation();
  const [showNotification, setShowNotification] = useState(false);
  const [showModifyInputs, setShowModifyInputs] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const userData = useSelector((state: any) => state.userDetails.userData);
  const lineOfBusiness: string = userData?.line_of_business || "";
  const hasCompletedOnboarding = !userData?.show_onboarding_popup;

  const handleModifyInputsClick = () => {
    const eventName = hasCompletedOnboarding ? trackingEventDictionary.intelHubModifyInputsClick : trackingEventDictionary.intelHubGetStartedClick;
    trademoTrackingEvents(eventName, generateTrackingObject("intel-hub", pathname, getUserActivePlan()));
    setShowModifyInputs(true);
  };

  return (
    <IntelLayout type={"intelHub"} pageTitle="AI Prospecting | Trademo Intel" setNotification={setShowNotification} showNotification={showNotification}>
      {showModifyInputs && <ModifyInputs onClose={() => setShowModifyInputs(false)} onSuccess={() => setRefreshKey((prev) => prev + 1)} />}

      <div className={`tw-flex tw-w-full tw-flex-col tw-gap-4 tw-px-4 tw-py-4 ${showModifyInputs ? "tw-hidden" : ""}`}>{SUPPORTED_PERSONAS.includes(lineOfBusiness) && <RecommendationsView key={lineOfBusiness} lineOfBusiness={lineOfBusiness} refreshKey={refreshKey} onModifyClick={handleModifyInputsClick} />}</div>
    </IntelLayout>
  );
};

export default IntelHub;
